import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Injector, Input, OnInit } from '@angular/core';
import { DevicesClass } from '@app/core/classes/component/devices.class';

export enum CrowdfundingViewTypes {
  Helper,   // 0
  Donate,   // 1
  About,    // 2
}

@Component({
  selector: 'shared-crowdfunding',
  templateUrl: 'crowdfunding.component.html',
  styleUrls: [`./crowdfunding.component.scss`],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CrowdfundingComponent extends DevicesClass implements OnInit {
  public CVTypes = CrowdfundingViewTypes;

  public CrowdLink: string = 'https://yoomoney.ru/fundraise/thoCyQID5vA.221227';
  public CrowdCountCurrent: number = 33000;
  public CrowdCountTotal: number = 500000;
  public CrowdCountCount: number = 160;
  public CrowdCountPercent: string = (this.CrowdCountCurrent / this.CrowdCountTotal * 100).toFixed();

  @Input() CrowdfundingView: CrowdfundingViewTypes;

  constructor(injector: Injector,
    public cdr: ChangeDetectorRef
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.cdr.markForCheck()
  }

  onCrowdRouterLink(): void {
    window.open(this.CrowdLink, '_blank').focus();
  }

  onParseNumberValue(value: number): string {
    return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
  }
}
